import moment, { Moment } from 'moment'

const stringDateTimeToMoment = (str: string):Moment => {
  return moment(str, 'DD-MM-YYYY HH:mm:ss')
}

const toString = (moment:Moment):string => {
  return moment.format('DD-MM-YYYY')
}

export const momentAdapter = {
  stringDateTimeToMoment, toString
}
